class AlertHelper {
    constructor() {
        this.alert = alert
    }

    show(alert, title, desc = '', type = 'success', autoClosing = true) {
        //error types: success, info, warning, error
        //alert positions: 'top right', 'top left', 'bottom left', 'bottom right'
        //iconTypes: 'solid', 'regular'
        alert.value.showAlert(
            type,
            desc,
            title,
            {
                iconSize: 35,
                iconType: 'solid',
                position: 'top right'
            }
        );

        if (autoClosing)
            this.close(alert);
    }

    close(alert) {
        setTimeout(() => {

        alert.value.closeAlert();
        }, 10000)
    }
}

export default new AlertHelper();
